import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import "simplebar-react/dist/simplebar.min.css";
import constant from "@/utils/constant";
import ParticipantsList from "./participants-list";
import { Styled } from "../../styles";
import ParticipantsStepper from "./participants-stepper";
import { useFormContext } from "react-hook-form";
import useQueryOrganizations from "@/hooks/queries/useQueryOrganizations";
import useQueryBrands from "@/hooks/queries/useQueryBrands";
import useQueryProducts from "@/hooks/queries/useQueryProducts";
import { Button } from "@dippi/ui";

type ParticipantsMode = "stepper" | "list";

const Participants: React.FC = () => {
    const GRID_SPACING = constant.GRID_SPACING;
    const [participantsMode, setParticipantsMode] = useState<ParticipantsMode>("stepper");

    const { watch, setValue } = useFormContext();

    const organizationId = watch("selectedOrganizationId");
    const brandId = watch("selectedBrandId");

    const { data: organizations } = useQueryOrganizations();
    const { data: brands } = useQueryBrands(organizationId);
    const { data: products } = useQueryProducts(organizationId, brandId);

    const mode = participantsMode === "stepper" ? "list" : "stepper";
    const button = participantsMode === "stepper" ? "View" : "Add";

    const handleModeChange = () => {
        setParticipantsMode(mode);
        setValue("selectedOrganizationId", "");
        setValue("selectedBrandId", "");
    };

    return (
        <Styled.Container container item xs={12} gap={GRID_SPACING}>
            <Grid item container xs={12} display="flex" gap={GRID_SPACING}>
                <Typography variant="h3">Participants</Typography>
                <Button variant="outlined" onClick={handleModeChange}>
                    {button}
                </Button>
            </Grid>
            <Grid item container xs={12} minHeight={350} minWidth={400}>
                {participantsMode === "stepper" ? (
                    <Grid item container xs="auto">
                        <ParticipantsStepper
                            organizations={organizations}
                            brands={brands}
                            products={products}
                        />
                    </Grid>
                ) : (
                    <Grid item container xs="auto">
                        <ParticipantsList
                            organizations={organizations}
                            brands={brands}
                            products={products}
                        />
                    </Grid>
                )}
            </Grid>
        </Styled.Container>
    );
};

export default Participants;
